export const getUserType = user => {
    const userType = user?.attributes?.profile?.publicData?.userType;
    return userType;
  };
  
  export const isCurrentUserAdmin = user => {
    // The user should be the currentUser
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isAdmin) ||
      false
    );
  };
  
  export const canUserResubmitApproval = user => {
    // Current User
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isRejectedOne &&
        user.attributes.profile.protectedData.reApproval &&
        !user.attributes.profile.protectedData.reApprovalDescription) ||
      false
    );
  };
  export const isUserPendingApproval = user => {
    return (
      (user &&
        user?.attributes &&
        user.attributes.state === 'pendingApproval') ||
      false
    );
  };
  export const isPermanentRejected = user => {
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isRejectedTwo) ||
      false
    );
  };
  
  export const getUserFirstAndLastName = user => {
    const firstName = user?.attributes?.profile?.firstName;
    const lastName = user?.attributes?.profile?.lastName;
    return { firstName, lastName };
  };
  